import CompetitorAlternativePage from '@/components/Pages/CompetitorAlternativePage';
import { TYPINGMIND_ALTERNATIVE } from '@/constants/competitorAlternatives';

export default function TypingMindAlternativePage() {
  return (
    <CompetitorAlternativePage
      title="TypingMind Alternative — No API Keys Needed"
      description="A TypingMind alternative with GPT, Claude, Gemini, and Arya included — no API keys. Private workspace, images, video, and apps."
      canonical="/typingmind-alternative"
      keywords="TypingMind alternative, alternative to TypingMind, TypingMind Super Intelligence alternative, better than TypingMind, TypingMind competitor, apps like TypingMind, free TypingMind alternative, best TypingMind alternative"
      page={TYPINGMIND_ALTERNATIVE}
    />
  );
}
